import React from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
} from "react-router-dom";
import OfferDetails from "./pages/offerDetails";
import VehicleDetails from "./pages/vehicleDetails";
import LoanDetails from "./pages/LoanDetails";
import ReviewDetails from "./pages/reviewDetails";
import PersonalDetails from "./pages/personalDetails";
import Confirmation from "./pages/confirmation";
import SanctionLetterApproval from "./pages/sanctionLetterApproval";
import Declaration from "./pages/declaration";
import higherLoanApplyForm from "../common/page/higherLoanApplyForm";

const ZDRoute = () => (
    <Router basename="/zd-10-seconds">
        <Switch>
            <Redirect exact from="/" to="/offer" />
            <Route exact path="/offer" component={OfferDetails} />
            <Route exact path="/vehicle-details" component={VehicleDetails} />
            <Route exact path="/loan-details" component={LoanDetails} />
            <Route exact path="/review" component={ReviewDetails} />
            <Route exact path="/personal-details" component={PersonalDetails} />
            <Route exact path="/confirmation" component={Confirmation} />
            <Route
                exact
                path="/sanction-letter-approval"
                component={SanctionLetterApproval}
            />
            <Route exact path="/declaration" component={Declaration} />
            <Route
                exact
                path="/higher-loan-apply-form"
                component={higherLoanApplyForm}
            />
            <Route exact path="/error">
                <h1>Something went wrong</h1>
            </Route>
            <Route exact>
                <h1>404 not Found</h1>
            </Route>
        </Switch>
    </Router>
);

export default ZDRoute;
